module.exports = __webpack_public_path__ + "fonts/Career-2.b8c5da45.ttf";